import BuilderAddToPortfolioFail from './BuilderAddToPortfolioFail';

export default BuilderAddToPortfolioFail;
